"use client";
import Link from "next/link";
import { useState } from "react";
import Image from "next/image";
import UseSticky from "../../hooks/UseSticky";
import NavMenu from "./Menu/NavMenu";
import Sidebar from "./Menu/Sidebar";
import HeaderOffcanvas from "./Menu/HeaderOffcanvas";
import { useLanguage } from "@/utils/LanguageContext";
import LanguageSwitcher from "./components/LanguageSwitcher";

const HeaderOne = () => {
    const { sticky } = UseSticky(); // Detect sticky state
    const [isActive, setIsActive] = useState<boolean>(false);
    const [offCanvas, setOffCanvas] = useState<boolean>(false);
    const { t, lang } = useLanguage();
    const mobileMenuId = "mobile-site-nav";

    return (
        <>
            <header id="header" className="relative z-20 header-layout1">
                <div id="sticky-header" className={`menu-area transparent-header ${sticky ? "sticky-menu" : ""}`}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="menu-wrap">
                                    <nav className="menu-nav">
                                        {/* Logo Section */}
                                        <div className="logo">
                                            <Link href={`/${lang}/home`} prefetch={false} aria-label={t("Home")}>
                                                <Image
                                                    src={sticky ? "/assets/img/logo/logo.png" : "/assets/img/logo/logo1.png"}
                                                    alt="Invtron DAO"
                                                    width={150}
                                                    height={40}
                                                    className="header-logo"
                                                />
                                            </Link>
                                        </div>
                                        
                                        <div className="navbar-wrap main-menu d-none d-lg-flex">
                                            <NavMenu />
                                        </div>
                                        <div className="header-action">
                                            <ul className="list-wrap">
                                                <li>
                                                    <LanguageSwitcher />
                                                </li>
                                            </ul>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() => setIsActive(true)}
                                            className="mobile-nav-toggler"
                                            aria-controls={mobileMenuId}
                                            aria-expanded={isActive}
                                            aria-label="Open navigation menu"
                                        >
                                            <i className="fas fa-bars"></i>
                                        </button>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <Sidebar style={false} isActive={isActive} setIsActive={setIsActive} />
            <HeaderOffcanvas offCanvas={offCanvas} setOffCanvas={setOffCanvas} />
        </>
    );
}

export default HeaderOne;
